export const SAVE_TARGETS = {
	EMAIL: 'email',
	NAME: 'name',
	PASSWORD: 'password',
	AUTO_PLAN_RENEW: 'autoPlanRenew',
};
